import { useTranslation } from 'react-i18next';

import { EmptyState } from './empty-state';
import { Intro, Page } from './page';
import { PageHead } from './page-head';
import { Section } from './section';
import { seoTitle } from '@todo/core/seo';

export type StubPage = 'saved' | 'account';

// A "coming soon" page in the site's style for a header or strip link whose
// content doesn't exist yet:
// Saved and Account (no accounts — what they should do is still open,
// docs/monorepo-plan.md stage 5.5). Copy under `stub.<page>`. Never `indexable`:
// there is nothing to index here.
export function ComingSoonPage({ page }: { page: StubPage }) {
  const { t } = useTranslation();
  const title = t(`stub.${page}.title`);

  return (
    <Page>
      <PageHead title={seoTitle(title)} description={t(`stub.${page}.intro`)} path={page} />
      <Section id="stub-title" level={1} title={title}>
        <Intro>{t(`stub.${page}.intro`)}</Intro>
        <EmptyState text={t(`stub.${page}.text`)} />
      </Section>
    </Page>
  );
}
